module.exports = __webpack_public_path__ + "static/assets/9a7700b1b9e8be15d170cf5c80df6dd1.png";